import installAccessContextGuard from './accessContextGuard'
import installProjectPrerequisiteGuard from './projectPrerequisiteGuard'
import installPublicRouteReferenceGuard from './publicRouteReferenceGuard'
import installRecordRoutePersistenceGuard from './recordRoutePersistenceGuard'

const TheContainer = () => import('@/containers/TheContainer')
const TenantAccessManagement = () => import('@/views/admin/TenantAccessManagement')
const MfaRecovery = () => import('@/views/admin/MfaRecovery')
const TenantBilling = () => import('@/views/admin/TenantBilling')
const AccessDenied = () => import('@/views/pages/AccessDenied')
const ProjectPrerequisiteRequired = () => import('@/views/pages/ProjectPrerequisiteRequired')

export default function registerTenantAccessRoutes (router) {
  router.addRoutes([
    {
      path: '/access-denied',
      name: 'AccessDenied',
      component: AccessDenied
    },
    {
      path: '/project-prerequisite-required',
      component: TheContainer,
      children: [
        {
          path: '',
          name: 'ProjectPrerequisiteRequired',
          component: ProjectPrerequisiteRequired,
          meta: { requiresAuth: true, pageTitle: 'プロジェクト設定が必要です' }
        }
      ]
    },
    {
      path: '/admin',
      component: TheContainer,
      children: [
        {
          path: 'tenant-access-management',
          name: '権限管理',
          component: TenantAccessManagement,
          meta: { requiresAuth: true, accessContext: true }
        },
        /*
         * 2要素認証の登録状況と、外す道。
         *
         * **`/admin` の下に置く。**この道は ApiAccessPolicyService が
         * TENANT_OWNER か TENANT_SYSTEM_ADMIN しか通さない
         * /tenant-access-management を叩く。画面だけ開けても中身は返らない。
         *
         * 2026-08-22 まで、端末を失くした人を救う道が1つも無かった。
         * **本番のDBを直接触るしか復旧手段が無かった。**
         */
        {
          path: 'mfa-recovery',
          name: '2要素認証の登録状況',
          component: MfaRecovery,
          /* 見出しはサイドバーの名前に合わせる。name は遷移の識別子。 */
          /*
           * 誰が開けるかは utils/accessPolicy.js の POLICIES で決める
           * （/admin/mfa-recovery の行）。ここに書かない。
           */
          meta: { requiresAuth: true, accessContext: true, pageTitle: '2要素認証リセット' }
        }
        ,{
          /*
           * 自社のご請求。**役割と機能の両方で守る。**
           *
           * back の ApiAccessPolicyService も /billing を
           * TENANT_OWNER / TENANT_SYSTEM_ADMIN に絞っている。
           * 誰が開けるかは utils/accessPolicy.js の POLICIES
           * （/admin/billing の行）。
           */
          path: 'billing',
          name: '請求・お支払い',
          component: TenantBilling,
          meta: { requiresAuth: true, accessContext: true }
        }
      ]
    }
  ])

  // 一覧行の旧paramsをURLへ残し、権限確認後に数値をUUIDへ置換する。
  // プロジェクト前提条件は解決済みの対象userIdを使うため最後に実行する。
  installRecordRoutePersistenceGuard(router)
  installAccessContextGuard(router)
  installPublicRouteReferenceGuard(router)
  installProjectPrerequisiteGuard(router)
}
